import * as css from './StatusLabel.css';
import {StatusColor} from './StatusLabel.css';

export type {StatusColor};

interface StatusLabelProps {
    text: string;
    color: StatusColor;
    image?: string;
    imagePosition?: 'start' | 'end';
    imageShiftY?: string;
    'data-cy'?: string;
}

function StatusLabel({text, color, image, imagePosition = 'start', imageShiftY, 'data-cy': dataCy = 'status-label'}: StatusLabelProps) {
    const img = image && <css.image src={image} alt="" aria-hidden $shiftY={imageShiftY} />;
    return (
        <css.strip $color={color} data-cy={dataCy}>
            {imagePosition === 'start' && img}
            <span>{text}</span>
            {imagePosition === 'end' && img}
        </css.strip>
    );
}

export default StatusLabel;
